<script>
import { mapGetters } from 'vuex';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
  },
  emits: ['select'],
  computed: {
    ...mapGetters({
      cannedMessages: 'getCannedResponses',
    }),
    items() {
      return this.cannedMessages
        .filter(cannedMessage => cannedMessage.enabled !== false)
        .map(cannedMessage => ({
          label: cannedMessage.short_code,
          key: cannedMessage.short_code,
          description: this.itemDescription(cannedMessage),
          hasImage: Boolean(cannedMessage.file?.file_url),
        }));
    },
  },
  watch: {
    searchKey() {
      this.fetchCannedResponses();
    },
  },
  mounted() {
    this.fetchCannedResponses();
  },
  methods: {
    itemDescription(cannedMessage) {
      if (cannedMessage.file?.file_url) {
        return this.$t('CANNED_MGMT.FORM.IMAGE.ONLY_IMAGE');
      }
      return cannedMessage.content || '';
    },
    fetchCannedResponses() {
      this.$store.dispatch('getCannedResponse', { searchKey: this.searchKey });
    },
    handleMentionClick(item = {}) {
      const cannedMessage = this.cannedMessages.find(
        message => message.short_code === item.key
      );
      if (!cannedMessage) return;

      this.$emit('select', cannedMessage);
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    @mention-select="handleMentionClick"
  />
</template>
